<template>
  <div class="d-flex">
    <div v-if="isLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
      <VProgressCircular indeterminate color="primary" />
    </div>
    <VList>
      <VListItem v-for="file in documents" :key="file.documentId" class="mb-2 border">
        <template #prepend>
          <VAvatar color="primary" icon="mdi-file" size="32" />
        </template>

        <div>
          <VListItemTitle>{{ file.documentTitle }}</VListItemTitle>
          <VListItemSubtitle> {{ file.documentType }} / {{ file.documentSize }} </VListItemSubtitle>
        </div>

        <template #append>
          <div class="d-flex align-center gap-2">
            <VBtn icon="mdi-eye" variant="text" color="primary" @click="handleViewDocument(file)" />
            <VBtn
              v-if="isShowDelete"
              icon="mdi-delete-outline"
              variant="text"
              color="red"
              @click="handleDeleteDocument(file)"
            />
          </div>
        </template>
      </VListItem>
    </VList>
    <DeleteDocumentModal
      v-model="isShowDeleteDocumentModal"
      :documentId="documentId"
      @success="handleDeleteDocumentSuccess"
    />
    <ViewDocumentModal v-model="isShowViewDocumentModal" :documentId="documentId" />
  </div>
</template>
<script>
// Service
import documentsService from '@/services/documents-service/documents.service';
// Components
import DeleteDocumentModal from '@/components/modals/DeleteDocumentModal/DeleteDocumentModal.vue';
import ViewDocumentModal from '@/components/modals/ViewDocumentModal/ViewDocumentModal.vue';
// Utils
import { formatDocuments } from '@/utils/formatData';
export default {
  name: 'DocumentList',

  emits: ['update:modelValue'],

  components: {
    DeleteDocumentModal,
    ViewDocumentModal
  },

  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    recordId: {
      type: String
    },
    isShowDelete: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: true,
      documents: [],
      isShowViewDocumentModal: false,
      isShowDeleteDocumentModal: false,
      documentId: null
    };
  },

  mounted() {
    this.getDocuments();
  },

  methods: {
    async getDocuments() {
      if (!this.recordId) {
        return;
      }
      this.isLoading = true;
      try {
        const { documents } = await documentsService.getDocuments({ recordId: this.recordId });
        this.documents = formatDocuments(documents ?? []);
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('update:modelValue', this.documents);
        this.isLoading = false;
      }
    },
    // View Document
    handleViewDocument(item) {
      if (!item?.documentId) {
        return;
      }
      this.isShowViewDocumentModal = true;
      this.documentId = item.documentId;
    },
    // Delete Document
    handleDeleteDocument(item) {
      if (!item?.documentId) {
        return;
      }
      this.isShowDeleteDocumentModal = true;
      this.documentId = item.documentId;
    },
    handleDeleteDocumentSuccess() {
      this.getDocuments();
    }
  }
};
</script>
